import filter from "@/api/filter";
export const config = {
  data() {
    return {
      columns: [],
    }
  },
  mounted() {
    this.getColumns();
  },
  methods: {

    getColumns() {
      const columns = [
        {
          title: "出单机构/团队",
          align: "center",
          minWidth: 200,
          show: true,
          render(h, params) {
            const text = params.row.orgName+'/'+params.row.groupName;
            return h("div", text);
          }
        },
        {
          title: "保单号",
          key: "policyNo",
          align: "center",
          minWidth: 230,
          show: true,
        },
        {
          title: "理赔结果",
          key: "claimsResult",
          align: "center",
          minWidth: 100,
          show: this.claimsState == 1,
          render(h, params) {
            const res = params.row.claimsResult;
            if (res == 0) {
              return h("div", "理赔失败");
            } else if (res == 1) {
              return h("div", "理赔成功");
            }
          }
        },

        {
          title: "联系人姓名",
          key: "contactName",
          align: "center",
          minWidth: 110,
          show: true,
        },
        {
          title: "联系方式",
          key: "contactMobile",
          align: "center",
          minWidth: 130,
          show: true,
        },
        {
          title: "出险产品",
          key: "productName",
          align: "center",
          minWidth: 230,
          show: true,
        },
        {
          title: "出险人",
          key: "accidentPerson",
          align: "center",
          minWidth: 100,
          show: true,
        },
        {
          title: "业务员",
          key: "salesmanName",
          align: "center",
          minWidth: 100,
          show: true,
        },
        {
          title: "报案时间",
          key: "caseDate",
          align: "center",
          minWidth: 120,
          render(h, params) {
            const res = params.row.caseDate;
            return h("div", filter.filterTime(res, "YYYY-MM-DD"));
          },
          show: true,
        },
        {
          title: "理赔结案时间",
          key: "claimsCaseDate",
          align: "center",
          minWidth: 150,
          show: this.claimsState == 1,
          render(h, params) {
            const res = params.row.claimsCaseDate;
            return h("div", filter.filterTime(res, "YYYY-MM-DD"));
          }
        },
        {
          title: "理赔金额",
          key: "claimsAmount",
          align: "center",
          minWidth: 140,
          show: this.claimsState == 1,
          render(h, params) {
            return h("div", params.row.claimsAmount||'-');
          }
        },

        {
          title: "操作",
          slot: "action",
          align: "center",
          width: this.claimsState == 0?170:140,
          show: true,
          fixed: 'right'
        }
      ]
      this.columns = columns.filter(item => item.show);
    }
  }
}
